import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import blogData from '../data/blog.json';

const BlogDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const foundPost = blogData.find(p => p.slug === slug);
    setPost(foundPost);
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return (
      <div className="page-not-found">
        <div className="not-found-container">
          <h1>Post Not Found</h1>
          <Link to="/blog" className="btn-primary">
            <ArrowLeft size={18} />
            {t('blog.backToBlog')}
          </Link>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    const lines = post.content.split('\n');
    return lines.map((line, index) => {
      if (line.startsWith('# ')) {
        return <h1 key={index} className="blog-content-h1">{line.substring(2)}</h1>;
      } else if (line.startsWith('## ')) {
        return <h2 key={index} className="blog-content-h2">{line.substring(3)}</h2>;
      } else if (line.startsWith('### ')) {
        return <h3 key={index} className="blog-content-h3">{line.substring(4)}</h3>;
      } else if (line.startsWith('**') && line.endsWith('**')) {
        return <p key={index} className="blog-content-bold">{line.substring(2, line.length - 2)}</p>;
      } else if (line.trim() === '') {
        return <div key={index} className="blog-content-spacer"></div>;
      } else {
        return <p key={index} className="blog-content-p">{line}</p>;
      }
    });
  };

  return (
    <div className="page-blog-detail">
      <article className="blog-detail">
        <div className="blog-detail-header">
          <div className="blog-detail-container">
            <Link to="/blog" className="back-link">
              <ArrowLeft size={18} />
              {t('blog.backToBlog')}
            </Link>
            
            <div className="blog-detail-category">{post.category}</div>
            <h1 className="blog-detail-title">{post.title}</h1>
            
            <div className="blog-detail-meta">
              <span className="blog-detail-meta-item">
                <User size={16} />
                {post.author}
              </span>
              <span className="blog-detail-meta-item">
                <Calendar size={16} />
                {new Date(post.date).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </span>
              <span className="blog-detail-meta-item">
                <Clock size={16} />
                {post.readTime}
              </span>
            </div>
          </div>
        </div>

        <div className="blog-detail-image">
          <img src={post.coverImage} alt={post.title} />
        </div>

        <div className="blog-detail-content">
          <div className="blog-detail-container">
            {renderContent()}
          </div>
        </div>
      </article>

      <section className="blog-detail-cta">
        <div className="blog-detail-container">
          <h2 className="blog-cta-title">{t('blog.wantToLearn')}</h2>
          <p className="blog-cta-text">
            {t('blog.wantToLearnText')}
          </p>
          <a href="https://wa.me/5588996527079" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large">
            {t('blog.getInTouch')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default BlogDetail;